import FaqContainer from './FaqContainer';
export default FaqContainer;
